import { Link } from "react-router-dom";
import React from "react";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import images from "@/utils/images";
import { providerRoute as provider } from "@/config/roles";

export function PatientsCard({ isUserPCP, patientCount }) {
  return (
    <DashboardCard2 className="tw:justify-between tw:lg:min-h-50" rawChildren>
      <div className="tw:flex tw:items-center tw:justify-between">
        <p className="fs-30 fs-xl-50 mb-0 tw:font-bold">{patientCount}</p>

        <img className="d-none d-md-block" src={images("./provider/brain.svg")} />

        {isUserPCP && (
          <Link className="d-md-none d-block" to={provider + "/patient/add"}>
            <img className="mt-2 mb-2 pt-1 pb-1" src={images("./provider/Oval.svg")} />
          </Link>
        )}
      </div>

      <div className="d-flex align-items-center justify-content-between">
        <p className="CardText fs-lg-20 fs-14">Number of Patients in Platform</p>

        {isUserPCP && (
          <Link to={provider + "/patient/add"}>
            <img className="d-md-block d-none" src={images("./provider/Oval.svg")} />
          </Link>
        )}
      </div>
    </DashboardCard2>
  );
}
